import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUltimateFix = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 26,
	height: 26,
	viewBox: "0 0 26 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_5061_2512)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M21.1768 7.40004C21.1662 7.38038 21.1513 7.36072 21.1344 7.34543C21.0282 7.23619 20.8562 7.23619 20.75 7.34543L17.0908 11.1096L15.6489 9.62619L19.3101 5.85987C19.3271 5.84239 19.3398 5.82492 19.3526 5.80525C19.429 5.67199 19.3866 5.50159 19.257 5.42294C17.1715 4.15585 14.4405 4.44641 12.646 6.29024C11.2231 7.75395 10.7516 9.82936 11.2337 11.695L5.0113 18.096C4.94759 18.1616 4.95183 18.2686 5.01767 18.3364L8.62157 22.0437C8.6874 22.1114 8.79359 22.1158 8.85518 22.0502L15.0755 15.6514C16.8912 16.1495 18.9087 15.6667 20.3337 14.2008C22.1261 12.3548 22.4086 9.54536 21.1768 7.40004ZM19.2528 13.0867C18.0189 14.3559 16.167 14.6006 14.6953 13.8207L14.5084 14.0129L14.5063 14.0108L8.6874 19.9989L7.00544 18.2686L11.8921 13.2418C11.8921 13.2418 11.8921 13.244 11.8942 13.244L13.0155 12.0905C12.2573 10.5765 12.4952 8.6715 13.729 7.40223C14.127 6.99249 14.6062 6.67595 15.134 6.47424C15.6618 6.27253 16.2257 6.19039 16.7872 6.23344L13.9648 9.13465C13.8373 9.26593 13.7657 9.44391 13.7657 9.62947C13.7657 9.81503 13.8373 9.993 13.9648 10.1243L16.6088 12.8442C16.7364 12.9753 16.9094 13.049 17.0898 13.049C17.2702 13.049 17.4432 12.9753 17.5708 12.8442L20.3911 9.94296C20.4696 11.0746 20.0853 12.2325 19.2528 13.0867Z",
				fill: "#262626"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_5061_2512",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 26,
				height: 26,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgUltimateFix);
export { ForwardRef as ReactComponent };
